import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import isRecord from "~/helpers/isRecord";
import { buildReportRunPath } from "~reports/executions/helpers/reportRunResult";
import { RunHistoryKind } from "~reports/executions/helpers/runHistoryRow";

export const RUN_HISTORY_SOURCE_KIND = "runHistory";

export const REPORT_RUN_TARGET_KIND = "reportRun";

const REPORT_RUN_ROUTE_PATTERN = /^\/reports\/executions\/([^/?#]+)$/;

export interface RunHistorySourceCheckpoint {
	executionId: null | string;
	reportFilterId: null | string;
	reportName: string;
	searchText: string;
	view: RunHistoryKind;
}

const RUN_HISTORY_VIEWS: readonly unknown[] = Object.values(RunHistoryKind);

const isNullOrString = (value: unknown): boolean => value === null || typeof value === "string";

export const isRunHistorySourceCheckpoint = (value: unknown): value is RunHistorySourceCheckpoint =>
	isRecord(value) &&
	isNullOrString(value.executionId) &&
	isNullOrString(value.reportFilterId) &&
	typeof value.reportName === "string" &&
	typeof value.searchText === "string" &&
	RUN_HISTORY_VIEWS.includes(value.view);

export const matchReportRunReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const match = REPORT_RUN_ROUTE_PATTERN.exec(pathname);
	if (!match) return null;
	try {
		return { targetId: decodeURIComponent(match[1]), targetKind: REPORT_RUN_TARGET_KIND };
	} catch {
		return null;
	}
};

export const reportRunReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => buildReportRunPath(targetId),
	matchesRoute: matchReportRunReceiverRoute
};

const runHistoryEditorKey = (executionId: null | string): string => `run-history:${executionId ?? "list"}`;

export default runHistoryEditorKey;
